import { Enlace } from '../../router';
import { Icono } from '../Icono';
import { Logo } from './Logo';

const COLUMNAS = [
  {
    titulo: 'Para pacientes',
    enlaces: [
      { texto: 'Buscar profesionales', ruta: '/buscar' },
      { texto: 'Cómo funciona', ruta: '/inicio' },
      { texto: 'Crear mi cuenta', ruta: '/registro' },
    ],
  },
  {
    titulo: 'Para profesionales',
    enlaces: [
      { texto: 'Sumar mi consultorio', ruta: '/registro-profesional' },
      { texto: 'Planes y precios', ruta: '/planes' },
      { texto: 'Ingresar', ruta: '/login' },
    ],
  },
];

// El descargo no es relleno legal: en una plataforma de salud tiene que quedar claro
// que MedChoice conecta pero no atiende.
export function Pie() {
  return (
    <footer className="pie">
      <div className="pie__interior">
        <div className="pie__columnas">
          <div>
            <Logo a="/" />
            <p className="pie__lema">
              Conectamos pacientes con profesionales de la salud de manera directa, simple y
              confiable.
            </p>
            <div className="pie__contacto">
              <span className="pie__dato">
                <Icono nombre="map-pin" tamano={14} />
                Buenos Aires, Argentina
              </span>
              <a href="mailto:hola@medchoice.com.ar" className="pie__dato">
                <Icono nombre="mail" tamano={14} />
                hola@medchoice.com.ar
              </a>
            </div>
          </div>

          {COLUMNAS.map((c) => (
            <nav key={c.titulo} aria-label={c.titulo}>
              <h2 className="pie__titulo">{c.titulo}</h2>
              <ul className="pie__enlaces">
                {c.enlaces.map((e) => (
                  <li key={e.texto}><Enlace a={e.ruta}>{e.texto}</Enlace></li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <p className="pie__legal">
          MedChoice facilita la conexión entre pacientes y profesionales de la salud. Los
          servicios médicos los presta exclusivamente cada profesional matriculado, de forma
          independiente. Ante cualquier síntoma, consultá siempre con un profesional para el
          diagnóstico y el tratamiento.
        </p>
        <p className="pie__derechos">
          © {new Date().getFullYear()} MedChoice. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
